import React from 'react';

const ServiceCard = ({img, cardTitle, des, bgClass}) => {
    return (
        <div  className={`card card-compact bg-base-100 shadow-xl ${bgClass}`}>
            <figure  className='pl-2 w-12  block mx-auto justify-center py-4'>
                <img src={img} alt="Album"/>
            </figure>
            <div  className="card-body text-gray">
                <h2  className="card-title mb-4">{cardTitle}</h2>
                <p>{des}</p>
            </div>
        </div>
    );
};

export default ServiceCard;